import React, { ReactNode } from 'react';
import { Page as TMPage, PageProps } from '@/Components/shared';

interface PagePropsExt extends PageProps {
    header?: ReactNode;
}

/** @deprecated please use src/Components/page instead */
const Page = ({ children, topBar = null, header = null, ...props }: React.PropsWithChildren<PagePropsExt>) => {
    return (
        <>
            {header}
            <TMPage header={header} topBar={topBar} {...props}>
                {children}
            </TMPage>
        </>
    );
};

export default Page;
